import {mianApiPost,mianApiGet} from './http.js';
export const apiBookInit = data => mianApiPost('/book/bookinit.html',data);//总数据请求
export const apiImgLvjing = data => mianApiPost('/ajax/imgfilter.html',data);//更换滤镜
//通过module_id 获取navList和
export const apiModuleList = data => mianApiPost('/book/modulelist.html',data);//通过module_id & book_id获取 模板队列和模板主题队列
export const apiModuleListSelect = data => mianApiPost('/book/modulelistselect.html',data);//通过书本id和模板主题id 获取这一组的模板list
export const apiNewPage = data => mianApiPost('/book/newpage.html',data);//增加新页面
export const apiQrcode = data => mianApiPost('/book/qrcode.html',data);//生成二维码
export const apiSaveBooks = data => mianApiPost('/book/savebooks.html',data);//保存书本数据
//用户相关
export const apiUserLogin = data => mianApiPost('/user/login.html',data);//保存书本数据
export const apiUserInfo = data => mianApiPost('/user/info.html',data);//获取个人信息
export const apiUserModify = data => mianApiPost('/user/modify.html',data);//更新个人信息
export const apiBangdingModify = data => mianApiPost('/user/account.html',data);//修改绑定号码
export const apiDizhiModify = data => mianApiPost('/user/receiving.html',data);//修改收货地址
export const apiInspect = data => mianApiPost('/book/inspect.html',data);//获取检测结果
export const apiPay = data => mianApiPost('/book/pay.html',data);//支付页面
export const apiPayment = data => mianApiPost('/book/payment.html',data);//支付页面 - 生成订单
export const apiDiscount = data => mianApiPost('/userdiscount/getlist.html',data);//个人中心 - 获取我的优惠券队列
export const apiAliyunSignPolicy = data => mianApiPost('/user/aliyunsignpolicy.html',data);//获取阿里云OSS的签名与policy
export const apiPostobjectcallbackerror = data => mianApiPost('/ajax/postobjectcallbackerror.html',data);//阿里云上传图片 - 回调失败 图片错误记录
export const apiUserorders = data => mianApiPost('/order/lists.html',data);//获取订单
export const apiUsercancel = data => mianApiPost('/order/cancel.html',data);//取消订单
export const apiUserfinish = data => mianApiPost('/order/finish.html',data);//确认收货
export const apiDesignlist = data => mianApiPost('/book/designlist.html',data);//我的设计
export const apiDeldesign = data => mianApiPost('/user/deldesign.html',data);//删除我的设计
export const apiRestoredesign = data => mianApiPost('/user/restoredesign.html',data);//删除我的设计
export const apiBookidsenCryption = data => mianApiPost('/book/getbookids.html',data);//获取书本的id加密集合
export const apiTeachlist = data => mianApiPost('/teach/index.html',data);//获取书本的id加密集合
export const apiArticlelist = data => mianApiPost('/article/index.html',data);//获取书本的id加密集合
export const apiTeachcontent = data => mianApiPost('/teach/content.html',data);//获取单个文章数据

export const apiSys = data => mianApiPost('/sys/index.html',data);//获取轮播数据
export const apiCate = data => mianApiPost('/projectitems/getlists.html',data);//获取轮播数据
export const apiTheme = data => mianApiPost('/projectlist/getlists.html',data);//获取主题数据
export const apiThemedetail = data => mianApiPost('/projectlist/info.html',data);//获取主题详情
export const apiThememake = data => mianApiPost('/projectlist/make.html',data);//获取主题详情



export const apiImgs = data => mianApiPost('/img/index.html',data);//获取主题详情
export const apiCountries = data => mianApiPost('/countries/index.html',data);//获取主题详情
export const apiItemstuijian = data => mianApiPost('/items/tuijian.html',data);//获取主题详情
export const apiHuodong = data => mianApiPost('/article/huodong.html',data);//获取首页活动
export const apiJiangzuo = data => mianApiPost('/jiangzuo/tuijian.html',data);//获取首页活动
export const apiHxarticle = data => mianApiPost('/article/index.html',data);//获取首页华夏新闻-带分页

export const apiCountriesinfo = data => mianApiPost('/countries/info.html',data);//获取国家详情
export const apiCountriestypes = data => mianApiPost('/countries/types.html',data);//获取国家详情
export const apiCountriesitems = data => mianApiPost('/items/countryitems.html',data);//获取国家详情
export const apiYuyue = data => mianApiPost('/index/yuyue.html',data);//更新个人信息
export const apiAssess = data => mianApiPost('/index/assess.html',data);//提交评估
export const apiCountrieslist = data => mianApiPost('/countries/countrieslist.html',data);//更新个人信息
export const apiItemsinfo = data => mianApiPost('/items/info.html',data);//更新个人信息

export const apiZhuantibanner = data => mianApiPost('/img/ztbanner.html',data);//专题页banner
export const apiZhuantimenu = data => mianApiPost('/countries/zhuanticountries.html',data);//专题页导航
export const apiZhuantilist = data => mianApiPost('/project/index.html',data);//专题页专题列表



export const apiVediobanner = data => mianApiPost('/img/vediobanner.html',data);//专题页banner
export const apiVediomenu = data => mianApiPost('/countries/vediocountries.html',data);//专题页导航
export const apiVediolist = data => mianApiPost('/jiangzuo/index.html',data);//专题页专题列表

export const apiAssesslabel = data => mianApiPost('/index/assesslabel.html',data);//专题页专题列表 
export const apiItemslist = data => mianApiPost('/items/index.html',data);//专题页专题列表 
export const apiItemscost = data => mianApiPost('/items/cost.html',data);//项目的金额明细

export const apiZiliaocountrys = data => mianApiPost('/index/ziliaocountrys.html',data);//获取资料的国家
export const apiFilefrom = data => mianApiPost('/index/filefrom.html',data);//获取资料提交
export const apiDuibilabel = data => mianApiPost('/index/duibilabel.html',data);//获取资料提交
export const apiDuibi = data => mianApiPost('/index/countryduibi.html',data);//获取资料提交

export const apiDazhoulist = data => mianApiPost('/continents/index.html',data);//获取资料提交
export const apiGuolist = data => mianApiPost('/countries/itemscountry.html',data);//获取资料提交
export const apiTypelist = data => mianApiPost('/tages/index.html',data);//获取资料提交
export const apiItems = data => mianApiPost('/items/getlists.html',data);//获取资料提交

export const apiDaohang = data => mianApiPost('/index/daohang.html',data);//获取资料提交
export const apiArticlenav = data => mianApiPost('/article/nav.html',data);//获取资料提交
export const apiContent = data => mianApiPost('/article/info.html',data);//获取资料提交
export const apiSeo = data => mianApiPost('/index/seo.html',data);//获取资料提交
export const apiMinizt = data => mianApiPost('/index/minizt.html',data);//获取资料提交
export const apiNumbers = data => mianApiPost('/index/numbers.html',data);//获取资料提交

export const apiLoginSms = data => mianApiPost('/message/sendsms.html',data);//获取登录验证码操作
export const apiGetmessage = data => mianApiPost('/index/getmessage.html',data);//获取登录验证码操作


// WEBPACK FOOTER //
// ./src/request/api.js